import Auth from '../models/Auth';

class StorageService {
    static AUTH_KEY = 'auth_data';

    static saveAuth(auth) {
        const data = {
            name: auth.name,
            email: auth.email,
            token: auth.token,
            user: auth.user,
            is_admin: auth?.is_admin
        };
        localStorage.setItem(this.AUTH_KEY, JSON.stringify(data));
    }

    static getAuth() {
        const data = localStorage.getItem(this.AUTH_KEY);
        if (!data) return null;

        const parsed = JSON.parse(data);
        return new Auth(parsed.name, parsed.email, parsed.token, parsed.user, parsed.is_admin);
    }

    static clearAuth() {
        localStorage.removeItem(this.AUTH_KEY);
    }
}

export default StorageService;
